/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskAttachment
 */
export interface TaskAttachment {
    /**
     * 
     * @type {string}
     * @memberof TaskAttachment
     */
    taskAttachmentId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskAttachment
     */
    taskAttachmentName?: string;
}

/**
 * Check if a given object implements the TaskAttachment interface.
 */
export function instanceOfTaskAttachment(value: object): value is TaskAttachment {
    return true;
}

export function TaskAttachmentFromJSON(json: any): TaskAttachment {
    return TaskAttachmentFromJSONTyped(json, false);
}

export function TaskAttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskAttachment {
    if (json == null) {
        return json;
    }
    return {
        
        'taskAttachmentId': json['taskAttachmentId'] == null ? undefined : json['taskAttachmentId'],
        'taskAttachmentName': json['taskAttachmentName'] == null ? undefined : json['taskAttachmentName'],
    };
}

export function TaskAttachmentToJSON(json: any): TaskAttachment {
    return TaskAttachmentToJSONTyped(json, false);
}

export function TaskAttachmentToJSONTyped(value?: TaskAttachment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskAttachmentId': value['taskAttachmentId'],
        'taskAttachmentName': value['taskAttachmentName'],
    };
}

